import type { Action } from '@ngrx/store';
import { createAction, createReducer, on, props } from '@ngrx/store';
import type { IUserStatus } from '@rdlabo/odss-mobile-hono/src/api/auth/api';

export const defaultProfile = (): IUserStatus => ({
  profile: {
    aeId: null,
    permission: null,
    companyId: null,
    name: null,
    companyName: null,
    companyKana: null,
    position: null,
    portableTelephone: null,
    mailAddress: null,
    lineId: null,
    note: null,
  },
});

export const actionStatus = createAction('[STORE]', props<IUserStatus>());

const ReducerFunction = createReducer(
  defaultProfile(),
  on(actionStatus, (state, reload) => {
    return reload;
  }),
);

export function reducer(state: IUserStatus, action: Action) {
  return ReducerFunction(state, action);
}
